// 积分兑换通用商城购物积分类型
export const transferType = {
  gold: 29, // 奖金积分转购物积分
  netStoreIncomePoints: 30, // 商家余额转购物积分
  firstGold: 126, // 奖金积分转店长采购积分
  firstNetStoreIncomePoints: 127 // 商家余额转店长采购积分

}



// WEBPACK FOOTER //
// ./src/utils/constant.js